export const isObject = (value: any) =>
  typeof value !== 'string' &&
  typeof value !== 'number' &&
  typeof value !== 'boolean' &&
  typeof value !== 'function' &&
  value !== undefined;
